import React, { useContext, useEffect, useRef, useState } from "react"
import { DropDown } from "../../../../../components/dropDown/DropDown";
import { formatDate2, formatForInputValue, formatTimeForInputValue } from "../../../../../utils/dateFormats";
import { ISessionErrors } from "./AddSessionValidate";
import { IClientData, IRepeatParams } from "../../../../../types/dashboard";
import { externalSetter } from "../../../../../utils/externalSetter";
import { RepeatOptionsForm } from "./RepeatOptionsForm";
import { AppContext } from "../../../../../appContext";
import { SelectTime } from "../../../../../components/selectTime/SelectTime";

export interface IAddSessionFormData {
    title: string,
    selectedClient: string,
    date: Date,
    timeFrom: Date,
    timeTo: Date,
    repeatParams: IRepeatParams
}

interface IAddSessionFormProps{
    clients: Array<IClientData>;
    errors: ISessionErrors;
    data: IAddSessionFormData;
    onChange: (value: (last: IAddSessionFormData) => IAddSessionFormData) =>void;
}

export const AddSessionForm = ({errors, clients, data, onChange}: IAddSessionFormProps)=>{
    const changeSetter = function <T extends keyof typeof data>(param: T) {return externalSetter(data, param, onChange)};
    const title = data.title;
    const setTitle = changeSetter('title');
    const date = data.date;
    const setDate = changeSetter('date');
    const timeFrom = data.timeFrom;
    const setTimeFrom = changeSetter('timeFrom');
    const timeTo = data.timeTo;
    const setTimeTo = changeSetter('timeTo');
    const repeatParams = data.repeatParams;
    const setRepeatParams = changeSetter('repeatParams');
    const selectedClient = data.selectedClient;
    const setSelectedClient = changeSetter('selectedClient');

    const {cheat, translate} = useContext(AppContext);
    const [showTimeFromPicker, setShowTimeFromPicker] = useState(false);
    const [showTimeToPicker, setShowTimeToPicker] = useState(false);
    const timeFromRef = useRef<HTMLDivElement>(null);
    const timeToRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        const handler = (e: MouseEvent) => {
            if (timeFromRef.current && !timeFromRef.current.contains(e.target as Node)) setShowTimeFromPicker(false);
            if (timeToRef.current && !timeToRef.current.contains(e.target as Node)) setShowTimeToPicker(false);
        };
        document.addEventListener('mousedown', handler);
        return () => document.removeEventListener('mousedown', handler);
    }, []);

    return <>
        <div className="addSession_addTitle">
            <input className="addSession_addTitle_input" placeholder={translate('session_add_title')} value={title} onChange={(e)=>setTitle(e.target.value)}/>
        </div>
        <div className="addSession_inputs">
            <div className="addSession_formItem">
                <div className="addSession_icon addSession_time_icon"></div>
                <div>
                    <div className="addSession_formItem_content addSession_formItem_content--date">
                        <div className={`addSession_dateBlock ${errors.date ? 'addSession_error' : ''}`}>
                            {/*Wednesday, 13 August*/}
                            <div className="addSession_dateOutput">{date ? formatDate2(date, translate) : translate('session_select_date')}</div>
                            <input className="addSession_dateInput" type="date" value={formatForInputValue(date)} onChange={(e)=>{
                                if (e.target.value) {
                                    const [year, month, day] = e.target.value.split('-').map(Number);
                                    const newDate = new Date(date || new Date());
                                    newDate.setFullYear(year, month - 1, day);
                                    setDate(newDate);
                                }
                            }}></input>
                        </div>
                        <div ref={timeFromRef} className={`addSession_dateBlock addSession_timeField ${errors.timeFrom ? 'addSession_error' : ''}`} onClick={() => setShowTimeFromPicker(true)}>
                            <div className="addSession_dateOutput addSession_timeField_label">{formatTimeForInputValue(timeFrom)}</div>
                            {showTimeFromPicker && (
                                <div className="addSession_timeField_popup" onClick={e => e.stopPropagation()}>
                                    <SelectTime selectedDate={timeFrom} onSelect={(d) => setTimeFrom(d)} defaultOpen />
                                </div>
                            )}
                        </div>
                        <div ref={timeToRef} className={`addSession_dateBlock addSession_timeField ${errors.timeTo ? 'addSession_error' : ''}`} onClick={() => setShowTimeToPicker(true)}>
                            <div className="addSession_dateOutput addSession_timeField_label">{formatTimeForInputValue(timeTo)}</div>
                            {showTimeToPicker && (
                                <div className="addSession_timeField_popup" onClick={e => e.stopPropagation()}>
                                    <SelectTime selectedDate={timeTo} onSelect={(d) => setTimeTo(d)} defaultOpen />
                                </div>
                            )}
                        </div>
                    </div>
                    <RepeatOptionsForm repeatParams={repeatParams} onChange={setRepeatParams}></RepeatOptionsForm>
                </div>
            </div>
            <div className="addSession_formItem">
                <div className="addSession_icon addSession_user_icon"></div>
                <div className="addSession_formItem_content">
                    <DropDown values={clients.map(it=>it.name)} onSelect={(selected)=>{setSelectedClient(clients[selected]?.id || '')}} selectedIndex={clients.findIndex(it=>it.id == selectedClient)}></DropDown>
                </div>
            </div>
            { cheat.debug && <div className="addSession_formItem">
                <div className="addSession_icon addSession_task_icon"></div>
                <div className="addSession_formItem_content">
                    {translate('session_add_task')}
                </div>
            </div> }
            { cheat.debug && <div className="addSession_formItem">
                <div className="addSession_icon addSession_description_icon"></div>
                <div className="addSession_formItem_content">
                    {translate('session_add_description')}
                </div>
            </div> }
        </div>
    </>
}